import { CurrencyIcon } from '@components'
import { PasswordTermsCheckIcon } from '@icons'
import cn from 'classnames'
import type React from 'react'
import './CurrencyBadge.scss'

interface Props {
  currencyCode: string
  isSelected: boolean
  onClick: (e: React.SyntheticEvent) => void
}

function CurrencyBadge({ currencyCode, isSelected, onClick }: Props) {
  return (
    <div className={cn('currency-badge-wrapper', { selected: isSelected })} onClick={onClick}>
      <div>
        <CurrencyIcon currency={currencyCode} circle size='2.2rem' />
      </div>
      <span data-test='currency' className='currency-name'>
        {currencyCode}
      </span>
      {isSelected && <PasswordTermsCheckIcon />}
    </div>
  )
}

export default CurrencyBadge
